<script setup lang="ts">
import { odsNavigation, odsNavigationItem } from 'omind-design-system/components/odsNavigation';
import { Spacing, FlexDirection, Align, Justify } from 'omind-design-system/tokens';
import { ButtonColor, ButtonType } from 'omind-design-system/components/odsButton';
import { reloadLocalesForLang } from '@/i18n';
import { ref, Ref } from 'vue';
import ActionMenu from '@/components/navigation/actionMenu/ActionMenu.vue';

import flagFR from '@/assets/images/flags/fr.png';
import flagEN from '@/assets/images/flags/gb.png';
import flagES from '@/assets/images/flags/es.png';
import { ActionMenuExposed } from '@/components/navigation/actionMenu/ActionMenu';
import { Lang } from '@/sdk';
import { useSessionStore } from '@/domains/-session/stores/useSessionStore';
import { odsIcon } from 'omind-design-system/components/odsIcon';

const actionMenuRef: Ref<null | (HTMLElement & ActionMenuExposed)> = ref(null);
const session = useSessionStore()

function setLang(lang: Lang) {
  session.lang = lang
  reloadLocalesForLang(lang);
  actionMenuRef.value?.closeAction()
}

function getLang() {
  return session.lang;
}

function getLangFlag() {
  switch (getLang()) {
    case 'fr':
      return flagFR
    case 'en':
      return flagEN
    case 'es':
      return flagES
  }
}
</script>

<template>
  <odsNavigation>
    <!-- <odsNavigationItem
            :label="''"
            :to="{name: 'home'}"
        >
          <template v-slot:icon>
            <span class="avatar">JF</span>
          </template>
</odsNavigationItem> -->
    <odsBox :padding="Spacing.None"
            :width="'auto'"
            style="position: relative">
      <odsNavigationItem class="navigation-settings"
                         :icon="'menu'"
                         :label="''"
                         @click="actionMenuRef?.openAction()">
        <template #icon>
          <div class="flag">
            <img :src="getLangFlag()" />
          </div>
          <odsIcon :name="'menu'" />
        </template>
      </odsNavigationItem>
      <ActionMenu ref="actionMenuRef"
                  :visible-backdrop="true"
                  class="action-menu-header">
        <odsBox :direction="FlexDirection.Column"
                :padding="Spacing.None"
                :align="Align.Start"
                :justify="Justify.Start"
                :height="'auto'">
          <odsBox :direction="FlexDirection.Column"
                  :padding="Spacing.Large"
                  :gap="Spacing.Standard"
                  :align="Align.Start"
                  :justify="Justify.Start"
                  :height="'auto'">
            <h4 v-html="$t('navigation.options.language')"></h4>
            <odsButton :type="getLang() === 'fr' ? ButtonType.Filled : ButtonType.Outline"
                       :color="getLang() === 'fr' ? ButtonColor.Primary : ButtonColor.Black"
                       :label="$t('lexicon.languages.fr')"
                       @click="setLang('fr')">
              <template #before>
                <div class="flag">
                  <img :src="flagFR" />
                </div>
              </template>
            </odsButton>
            <odsButton :type="getLang() === 'en' ? ButtonType.Filled : ButtonType.Outline"
                       :color="getLang() === 'en' ? ButtonColor.Primary : ButtonColor.Black"
                       :label="$t('lexicon.languages.en')"
                       @click="setLang('en')">
              <template #before>
                <div class="flag">
                  <img :src="flagEN" />
                </div>
              </template>
            </odsButton>
            <odsButton :type="getLang() === 'es' ? ButtonType.Filled : ButtonType.Outline"
                       :color="getLang() === 'es' ? ButtonColor.Primary : ButtonColor.Black"
                       :label="$t('lexicon.languages.es')"
                       @click="setLang('es')">
              <template #before>
                <div class="flag">
                  <img :src="flagES" />
                </div>
              </template>
            </odsButton>
          </odsBox>
        </odsBox>
      </ActionMenu>
    </odsBox>
  </odsNavigation>
</template>

<style lang="scss">
.ods-navigation-bottom {
  flex: 0 0 125px;
  display: flex;
  justify-content: end;
}

.navigation-settings {
  .ods-icon {
    width: 2rem;
    height: 2rem;
    flex: 0 0 2rem;
  }

  .flag {
    width: 2.2rem;
    height: 1.5rem;
    overflow: hidden;
    border-radius: var(--border-radius-standard);
    display: flex;
    align-items: center;
    justify-content: center;
    //border: solid 1px var(--color-neutral-10);

    img {
      height: 100%;
    }
  }
}

.avatar {
  text-transform: uppercase;
  width: 2.5rem !important;
  height: 2.5rem !important;
  font-size: 0.875rem !important;
}

.action-menu-header {
  .actions-dropdown {
    //min-height: 300px;
    min-width: 200px;

    h4 {
      color: var(--content-label-900);
    }

    .ods-button {
      .flag {
        width: 2.2rem;
        height: 1.5rem;
        overflow: hidden;
        border-radius: var(--border-radius-medium);
        display: flex;
        align-items: center;
        justify-content: center;
        border: solid 2px var(--color-neutral-10);

        img {
          height: 100%;
        }
      }
    }
  }
}
</style>
